/**
 * src/components/ScrollToTop.tsx — Scroll to top on route changes.
 * HashRouter doesn't have scroll restoration, so we handle it manually.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router';

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
